import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/kanban-stages'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'kanban_stages_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'kanban_stages_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'kanban_stages_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
